import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@/components/ui";
import Seo from "@/components/Seo";
import { ImmersiveShell } from "@/components/immersive/ImmersiveShell";
import { Reveal } from "@/components/immersive/Reveal";
import Breadcrumbs from "@/components/immersive/Breadcrumbs";

const GROUPS = [
  {
    title: "Services",
    links: [
      { to: "/home-care-services", label: "Home Care Services", desc: "Explore all in-home care service categories." },
      { to: "/senior-care-matching", label: "Senior Care Matching", desc: "How we match families with senior care." },
      { to: "/caregiver-matching", label: "Caregiver Matching", desc: "Matching based on your needs and preferences." },
    ],
  },
  {
    title: "Get started",
    links: [
      { to: "/intake", label: "Get Matched", desc: "Tell us your needs and get matched now." },
      { to: "/book-appointment", label: "Book an Appointment", desc: "Talk to a representative for guidance." },
      { to: "/how-it-works", label: "How It Works", desc: "The step-by-step matching process." },
    ],
  },
  {
    title: "For providers",
    links: [
      { to: "/for-agencies", label: "Become a Partner Agency", desc: "Join the HomecareMatches partner network." },
      { to: "/caregiver-apply", label: "Join as a Caregiver", desc: "Caregiver membership and application." },
    ],
  },
  {
    title: "Information",
    links: [
      { to: "/faqs", label: "FAQs", desc: "Answers about home care services." },
      { to: "/contact", label: "Contact", desc: "Get in touch with our team." },
      { to: "/privacy", label: "Privacy Policy", desc: "How we handle your information." },
      { to: "/terms", label: "Terms of Service", desc: "Terms for using HomecareMatches." },
    ],
  },
];

export default function Sitemap() {
  return (
    <ImmersiveShell>
      <Seo title="Sitemap" path="/sitemap"
        description="Sitemap for HomecareMatches — find home care services, senior care matching, caregiver matching, how it works, FAQs, and ways to get started." />
      <section className="imm-mkt-hero imm-wrap" data-testid="sitemap-page" style={{ minHeight: "auto", paddingTop: 20 }}>
        <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Sitemap" }]} />
        <Reveal className="imm-eyebrow" delay={80}>Sitemap</Reveal>
        <Reveal as="h1" delay={180}>Sitemap</Reveal>
        <Reveal as="p" delay={300}>Every important page on HomecareMatches, in one place.</Reveal>
      </section>

      <section className="imm-wrap" data-testid="sitemap-groups" style={{ paddingBottom: "8vh" }}>
        {GROUPS.map((g, gi) => (
          <Reveal key={gi} delay={gi * 60}>
            <div style={{ paddingTop: gi === 0 ? 0 : 8 }}>
              <h2 className="imm-svc-h2" style={{ marginTop: 24 }}>{g.title}</h2>
              <ul className="imm-sitemap-list">
                {g.links.map((l) => (
                  <li key={l.to}>
                    <Link className="imm-inline-link" to={l.to} data-testid={`sitemap-${l.to.replace(/\//g, "")}`}>{l.label} <Icon name="arrow-right" size={14} /></Link>
                    <span className="imm-sitemap-desc">{l.desc}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </section>
    </ImmersiveShell>
  );
}
